export const buildRatings = (
  categories: string[],
  values: Record<string, number>,
): Kudable.RatingInput[] =>
  categories
    .filter((category) => (values[category] ?? 0) > 0)
    .map((category) => ({ category, rating: values[category] }));
